import type { IResetPasswordData } from "@frontend-shared/types";
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { authApi } from "@/api/services";

export const useResetPassword = () => {
  const { t } = useTranslation("auth");

  return useMutation({
    mutationFn: (params: IResetPasswordData) => authApi.resetPassword(params),
    onSuccess: () => {
      toast.success(t("reset_password.success.title"), {
        description: t("reset_password.success.description"),
      });
    },
    meta: {
      fallbackMessage: t("reset_password.error"),
    },
  });
};
